"use client";

import { ChartLineIcon } from "../Icons";
import { TooltipWrapper } from "../Tooltip";

export type ViewPerformanceButtonProps = {
  /** Tooltip id suffix. */
  id: string;
  /** Performance Report deep-link. */
  href: string;
  /** Accessible and tooltip label. */
  label: string;
  /** Runs before navigation. */
  onClick?: () => void;
  /** Handles in-app navigation instead of following the anchor. */
  onNavigate?: (href: string) => void;
};

/** Desktop icon link to the Performance Report. */
export const ViewPerformanceButton = ({
  id,
  href,
  label,
  onClick,
  onNavigate,
}: ViewPerformanceButtonProps) => {
  return (
    <TooltipWrapper
      id={`view-performance-tooltip-${id}`}
      text={label}
      tooltipPlacement="top"
      color="blue"
      tooltipContainerClassName="!w-[unset]"
    >
      <a
        href={href}
        aria-label={label}
        data-testid="view-performance-button"
        onClick={(event) => {
          onClick?.();
          const isPlainPrimaryClick =
            event.button === 0 &&
            !event.metaKey &&
            !event.ctrlKey &&
            !event.shiftKey &&
            !event.altKey;

          if (onNavigate && isPlainPrimaryClick) {
            event.preventDefault();
            onNavigate(href);
          }
        }}
        className="flex h-[24px] w-[24px] items-center justify-center rounded-lg hover:bg-overlay-opacity-state-hover"
      >
        <span className="text-text-brand-default">
          <ChartLineIcon width={16} height={16} className="[&_path]:stroke-1" />
        </span>
      </a>
    </TooltipWrapper>
  );
};
